import { memo, useMemo } from 'react'

import { DateTime } from 'luxon'

import { DashboardModule, Table, Text } from '@domain-group/suit-theme'

import { PublicationEditionDeadline } from '@hooks/usePublicationEditionDeadlines'
import useSelector from '@hooks/useSelector'

import type { PublicationModel } from '@models/types'

const findCellColour = (publicationEdition: PublicationEditionDeadline) => {
  const { deadlineDate } = publicationEdition
  // @ts-expect-error TS2339
  const color = deadlineDate?.ts < DateTime.now().ts ? 'lightGrey' : ''

  return color
}

const buildColumns = (publications: PublicationModel[]) => [
  {
    title: 'Deadline',
    dataKey: 'title',
    render: (title: string, deadline: PublicationEditionDeadline) => (
      <Text color={findCellColour(deadline)}>{title}</Text>),
  },
  {
    title: 'Publication',
    dataKey: 'publicationId',
    render: (publicationId: number, deadline: PublicationEditionDeadline) => {
      const publication = publications[publicationId] || {}
      const { title } = publication

      return (<Text color={findCellColour(deadline)}>{title}</Text>)
    },
  },
  {
    title: 'Edition',
    dataKey: 'publicationDate',
    render: (publicationDate: string, deadline: PublicationEditionDeadline) => (
      <Text color={findCellColour(deadline)}>
        {/*
         // @ts-expect-error TS2554 */}
        {publicationDate.toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}
      </Text>
    ),
  },
  {
    title: 'Deadline',
    dataKey: 'deadlineDate',
    render: (date: string, deadline: PublicationEditionDeadline) => (
      <Text color={findCellColour(deadline)}>
        {/*
         // @ts-expect-error TS2339 */}
        { date?.toFormat('D T')}
      </Text>
    ),
  },
  {
    title: 'Due',
    dataKey: 'relativeDate',
    cellProps: {
      width: 130,
    },
    render: (relativeDate: string, deadline: PublicationEditionDeadline) => (
      <Text color={findCellColour(deadline)}>
        {relativeDate}
      </Text>
    ),
  },
  {
    title: 'Orders',
    dataKey: 'orderItemCount',
    cellProps: {
      textAlign: 'center',
      width: 80,
    },
    render: (orderItemCount: number, deadline: PublicationEditionDeadline) => (
      <Text color={findCellColour(deadline)}>
        {orderItemCount}
      </Text>
    ),
  },
]

interface PublicationEditionsTableProps {
  publicationEditionDeadlines: PublicationEditionDeadline[],
  title: string,
}

const PublicationEditionsTable = (props: PublicationEditionsTableProps) => {
  const { publicationEditionDeadlines, title } = props

  const publications = useSelector(reduxState => reduxState.entities.publications)

  // @ts-expect-error TS2345
  const memoColumns = useMemo(() => buildColumns(publications), [publicationEditionDeadlines.length])

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title={title}>
      {publicationEditionDeadlines.length > 0 && (
        <Table
          boxProps={{
            border: 'none', maxHeight: 800, overflowY: 'auto',
          }}
          // @ts-expect-error TS2322
          columns={memoColumns}
          data={publicationEditionDeadlines}
          stickyHeader
        />
      )}

      {publicationEditionDeadlines.length < 1 && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Upcoming Deadlines present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}
    </DashboardModule>
  )
}

export default memo(PublicationEditionsTable)
